/**
 * Authentication related types that match the backend DTOs
 */

export enum UserRole {
  SuperAdmin = 0,
  Admin = 1,
  Manager = 2,
  Guard = 3
}

export interface User {
  id: string;
  account: string;
  firstName?: string;
  lastName?: string;
  name?: string; // For backward compatibility
  fullName?: string; // From backend FullName property
  role: string | number;
  companyId?: string;
  companyName?: string;
  parentUserId?: string | null;
  createdAt?: string;
  lastLoginAt?: string;
  certificateNumber?: string | null;
  certificateExpiration?: string | null;
  isOwner?: boolean;
}

export interface AuthResult {
  success: boolean;
  token: string;
  refreshToken?: string;
  expiration: string;
  user: User;
  message?: string;
  challengeName?: string;
  challengeSession?: string;
  subscriptionInactive?: boolean;
}

export interface LoginRequest {
  account: string;
  password: string;
}

export interface RegisterUserRequest {
  name?: string;
  firstName?: string;
  lastName?: string;
  account: string;
  password: string;
  role: string | number;
  parentUserId?: string | null;
  companyId?: string;
  certificateNumber?: string | null;
  certificateExpiration?: string | null;
}

export interface UpdateUserRequest {
  name?: string;
  firstName?: string;
  lastName?: string;
  account?: string;
  password?: string;
  role?: string | number;
  parentUserId?: string | null;
  certificateNumber?: string | null;
  certificateExpiration?: string | null;
}
